import { environment } from "src/environments/environment";
import * as helpers from '../helpers/ui-helpers';
import { BuildServices } from "./normalize";
import { BaseJob } from "./job.type";
import { AnyJobBase } from "./any-job-base";
import { WaypointDetailsDialog } from "../dialogs/waypoint-details/waypoint-details.dialog";

export class Waypoint extends AnyJobBase {

  public value: BaseJob;
  public onTheWayCompleted = !environment.features.hasOnTheWay;
  public label: string;
  public _for: string = this.translateSvc.translate('LABEL.for');
  public riderName: string;
  public type = 'waypoint';

  constructor(value: BaseJob, services: BuildServices) {
    super(value, services);
    this.headerInfo.type = 'LABEL.waypoint',
    this.label = 'LABEL.waypoint';
    this.actions = this.getActions();
    this.typeIcons = [ helpers.TypeIcons.waypoint ];
    this.value.performTime = this.value.arriveTime;

    this.getActions();
    this.updateTimeBasedProperties();

  }

  public updateTimeBasedProperties = () => {
    const timeToDiff = this.scheduledStart;
    this.isLate = this.completed ? false : helpers.isInThePast(timeToDiff);
    const actions = this.getActions();
    if (JSON.stringify(actions) !== JSON.stringify(this.actions)) {
      this.actions = this.getActions();
    }
    this.headerInfo.timeTo = this.scheduledStart?.toRelative();
  };

  public tapForDetails = async () => {
    const detailModal = await this.modalController.create({
      cssClass: 'parascope-full-modal',
      component: WaypointDetailsDialog,
      componentProps: { routeEvent: this },
    });
    await detailModal.present();
    const dialog = detailModal.shadowRoot.querySelector('[role="dialog"]');
    dialog.setAttribute('aria-label', 'Job Details');
  };

  public arrive = async ({ action, checkLocation = true, checkHasArrived = true }) => {
    try {
      if (action) action.disabled = true;
      const hasArrived = checkHasArrived ? await this.locationSvc.checkHasArrived([ this ]) : true;
      if (!hasArrived) { return; }
      const odoUpdated = checkLocation ? await helpers.presentOdometer(this.modalController) : true;
      if (!odoUpdated) { return; }
      await this.dispatchSvc.arriveJobs([ this ]);
      const now = new Date();
      [ this ].forEach(_job => {
        _job.value.arriveTime = now.toISOString();
        _job.value.performTime = now.toISOString();
        _job.actions = _job.getActions();
      });
    } catch (error) {
      this.notificationSvc.error(error.message || error);
    } finally {
      if (action) action.disabled = false;
    }
  };

public depart = async ({ action }) => {
  try {
    if (action) action.disabled = true;
    await this.dispatchSvc.departJobs([ this ]);
    const now = new Date();
    [ this ].forEach(_job => {
      _job.value.departedTime = now.toISOString();
      _job.actions = _job.getActions();
    });
    this.completed = true;
  } catch (error) {
    console.error(error);
    this.notificationSvc.error(error.message || error);
  } finally {
    if (action) action.disabled = false;
  }
};

}
